export default $axios => {   
    return {
        async login(form) { 
            const response = await $axios.post('/simulator/login', form);
            
            if(response.status === 200) {
                $axios.setToken(true, response.data); 
                return response;
            }  
            
            return response;
        },
        async test() {  
            await $axios.get('/data'); 
        }
    }; 
}; 
 